<template>
  <page class="business-app">
    <header-component logo="business">
      <template v-if="showHeaderLinks">
        <a
          href="https://businessblog.blinkist.com"
          class="header-content__button header-link header-link--main js-pw-link"
          data-event-category="body-20210217-business_header"
          data-event-name="blog"
        >
          {{ $t("blog") }}
        </a>
        <a
          href="/content/business/plans"
          class="header-content__button header-link header-link--main js-pw-link"
          data-event-category="body-20210217-business_header"
          data-event-name="plans"
        >
          {{ $t("plans") }}
      </a>
        <button-component
          :copy="$t('demo')"
          class="hidden m:block"
          href="/content/business/book-a-demo"
          event-category="body-20210217-business_header"
          event-name="book-a-demo"
        />
      </template>
    </header-component>
    <router-view />
  </page>
</template>

<script>
import Page from "@/shared/page"
import HeaderComponent from "@/features/header/components"
import ButtonComponent from "@/shared/button"
import globals from "@/utils/globals"

const businessGlobals = globals.business || {}
const routes = globals.routes || {}

export default {
  name: "BusinessApp",
  components: {
    Page,
    HeaderComponent,
    ButtonComponent
  },
  startTeamPath: routes.startTeamPath,
  afterSignupPath: businessGlobals.afterSignupPath,
  afterLoginPath: businessGlobals.afterLoginPath,
  computed: {
    showHeaderLinks() {
      return this.$route.meta.showHeaderLinks
    }
  },
  i18n: {
    messages: {
      en: {
        blog: "Blog",
        plans: "Plans",
        demo: "Get in touch"
      },
      de: {
        blog: "Blog",
        plans: "Angebote",
        demo: "Demo buchen"
      }
    }
  }
}
</script>

<style lang="scss">
.business-app {
  #{&} &__header-demo-cta {
    @include media(max-width, m) {
      display: none;
    }
  }
}
</style>
